import React, { Component, useEffect, useState } from "react";
import ComponentAttendanceDetailMobile from "./ComponentAttendanceDetailMobile";
import ComponentAttendanceDetailWeb from "./ComponentAttendanceDetailWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentAttendanceDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("AttendanceDetail");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Attendance Detail",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentAttendanceDetailWeb></ComponentAttendanceDetailWeb>
      </BrowserView>
      <MobileView>
        <ComponentAttendanceDetailMobile></ComponentAttendanceDetailMobile>
      </MobileView>
    </>
  );
};

export default ComponentAttendanceDetail;
